import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import OptInPage from "./pages/OptInPage";
import VSLFunnel from "./pages/VSLFunnel";
import BookedPage from "./pages/BookedPage";
import "./styles/OptInPage.css";
import "./styles/VSLFunnel.css";
import "./styles/BookedPage.css";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<OptInPage />} />
          <Route path="/breakdown" element={<VSLFunnel />} />
          <Route path="/booked" element={<BookedPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
